export const telefoneMask = (value) => {
    if (value) {
        const regex = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
        var str = value.replace(/[^0-9]/g, "").slice(0, 11);
        return str.replace(regex, "($1)$2-$3");
    } else {
        return
    }

}